// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * core-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OneTimeLimitInfoAPIModel
 */
export interface OneTimeLimitInfoAPIModel {
    /**
     * 
     * @type {string}
     * @memberof OneTimeLimitInfoAPIModel
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof OneTimeLimitInfoAPIModel
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof OneTimeLimitInfoAPIModel
     */
    assetId: string;
}

export function OneTimeLimitInfoAPIModelFromJSON(json: any): OneTimeLimitInfoAPIModel {
    return OneTimeLimitInfoAPIModelFromJSONTyped(json, false);
}

export function OneTimeLimitInfoAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): OneTimeLimitInfoAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'amount': json['amount'],
        'assetId': json['assetId'],
    };
}

export function OneTimeLimitInfoAPIModelToJSON(value?: OneTimeLimitInfoAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': value.userId,
        'amount': value.amount,
        'assetId': value.assetId,
    };
}


